import { Rules } from '@shared/components/form-item/model';

export const updateDateMinMax = (value: string, rules: Rules | undefined): string => {
  const dateValue: Date = new Date(value);
  const dateMin = rules?.min ? new Date(rules.min) : null;
  const dateMax = rules?.max ? new Date(rules.max) : null;
  if (dateValue === null) {
    return '';
  }
  if (dateMin !== null && dateMin.getTime() > dateValue.getTime()) {
    value = rules?.min as string;
  }
  if (dateMax !== null && dateMax.getTime() < dateValue.getTime()) {
    value = rules?.max as string;
  }
  return value;
};

export const checkDate = (value: string): boolean => {
  return !!value;
};
